var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fish-card',{attrs:{"color":"purple","fluid":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("QR for tile "+_vm._s(_vm.tile))]),_vm._v(" "),_c('img',{ref:"qrimage"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62c2636e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QRComponent.vue
// module id = null
// module chunks = 